import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/jibie.png';
import _imports_2 from '../../../assets/select.png';
const _withScopeId = n => (_pushScopeId("data-v-1d3a1659"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  style: {
    "padding": "20px"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "16px",
    "color": "#181818",
    "margin-bottom": "20px"
  }
}, " 如果感觉真实的阅读能力与当前级别不匹配，请在下方手动调整。 ", -1));
const _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "space-evenly",
    "margin-bottom": "30px"
  }
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "align-items": "center",
    "font-weight": "bold",
    "margin-bottom": "10px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "margin-right": "5px"
  }
}), /*#__PURE__*/_createTextVNode(" 级别 ")], -1));
const _hoisted_9 = {
  style: {
    "width": "80%",
    "margin": "0 auto",
    "position": "relative",
    "margin-bottom": "40px"
  }
};
const _hoisted_10 = ["value"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "position": "absolute",
    "right": "0",
    "top": "0"
  }
}, null, -1));
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { onMounted, computed, ref } from "vue";
import { getLocalPid } from "../../../libs/util";
import { ElMessage } from "element-plus";
import { userSetLevel } from "../../../api/index";
export default {
  __name: 'ability_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const getPeriod = computed(() => {
      if (schoolPeriod.value === "X") return grade.filter(v => {
        return v.value[1] === "B" || v.value[0] === "X";
      });
      if (schoolPeriod.value === "C") return grade.filter(v => {
        return v.value[0] === "C";
      });
      if (schoolPeriod.value === "G") return grade.filter(v => {
        return v.value[0] === "G";
      });
      if (schoolPeriod.value === "D") return grade.filter(v => {
        return v.value[0] === "B" || v.value[0] === "Y";
      });
      return [];
    });
    const school = ["小学", "初中", "高中", "大学"];
    const vis = ref(true);
    const grade = [{
      name: "小一上 (0起点)",
      value: "X1s"
    }, {
      name: "小一下",
      value: "X1x"
    }, {
      name: "小二上",
      value: "X2s"
    }, {
      name: "小二下",
      value: "X2x"
    }, {
      name: "小三上",
      value: "X3s"
    }, {
      name: "小三下",
      value: "X3x"
    }, {
      name: "小四上",
      value: "X4s"
    }, {
      name: "小四下",
      value: "X4x"
    }, {
      name: "小五上",
      value: "X5s"
    }, {
      name: "小五下",
      value: "X5x"
    }, {
      name: "小六上",
      value: "X6s"
    }, {
      name: "小六下",
      value: "X6x"
    }, {
      name: "初一上",
      value: "C1s"
    }, {
      name: "初一下",
      value: "C1x"
    }, {
      name: "初二上",
      value: "C2s"
    }, {
      name: "初二下",
      value: "C2x"
    }, {
      name: "初三上",
      value: "C3s"
    }, {
      name: "初三下",
      value: "C3x"
    }, {
      name: "高一上",
      value: "G1s"
    }, {
      name: "高一下",
      value: "G1x"
    }, {
      name: "高二上",
      value: "G2s"
    }, {
      name: "高二下",
      value: "G2x"
    }, {
      name: "高三上",
      value: "G3s"
    }, {
      name: "高三下",
      value: "G3x"
    }, {
      name: "大一上",
      value: "B1s"
    }, {
      name: "大一下",
      value: "B1x"
    }, {
      name: "大二上",
      value: "B2s"
    }, {
      name: "大二下",
      value: "B2x"
    }, {
      name: "大三上",
      value: "B3s"
    }, {
      name: "大三下",
      value: "B3x"
    }, {
      name: "大四上",
      value: "B4s"
    }, {
      name: "大四下",
      value: "B4x"
    }, {
      name: "研一上",
      value: "Y1s"
    }, {
      name: "研一下",
      value: "Y1x"
    }, {
      name: "研二上",
      value: "Y2s"
    }, {
      name: "研二下",
      value: "Y2x"
    }, {
      name: "研三上",
      value: "Y3s"
    }, {
      name: "研三下",
      value: "Y3x"
    }, {
      name: "研四上",
      value: "Y4s"
    }, {
      name: "研四下",
      value: "Y4x"
    }];
    const user_grade_bak = ref("");
    let schoolPeriod = ref("");
    const checked = ref("");
    const init_user_grade_bak = ref("");
    const safeMes = computed(() => store.state.safeMes);
    const userInfo = computed(() => store.state.userInfo);
    onMounted(() => {
      console.log(route.query.type);
      const gradeVal = userInfo.value.grade || route.query.type;
      if (gradeVal) {
        init_user_grade_bak.value = user_grade_bak.value = gradeVal;
        if (gradeVal[1] == "B" || gradeVal == "X") {
          schoolPeriod.value = "X";
          checked.value = "小学";
        }
        if (gradeVal[0] == "C") {
          schoolPeriod.value = "C";
          checked.value = "初中";
        }
        if (gradeVal[0] == "G") {
          schoolPeriod.value = "G";
          checked.value = "高中";
        }
        if (gradeVal[0] == "B" || gradeVal[0] == "Y" || gradeVal == "D") {
          schoolPeriod.value = "D";
          checked.value = "大学";
        }
      }
    });
    const getSchoolList = index => {
      let arr = ["X", "C", "G", "D"];
      schoolPeriod.value = arr[index];
      checked.value = school[index];
      vis.value = false;
      setTimeout(() => {
        vis.value = true;
        user_grade_bak.value = getPeriod.value[0].value;
      }, 100);
    };
    //  改变选中值
    const changeOption = $event => {
      user_grade_bak.value = $event.target.value;
    };
    const submit = () => {
      if (!user_grade_bak.value) return ElMessage.error("请勾选调整后的年级");
      let obj = {
        ...safeMes.value,
        grade: user_grade_bak.value,
        pid: getLocalPid()
      };
      userSetLevel(encodeURIComponent(JSON.stringify(obj))).then(res => {
        let data = res.data;
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        store.commit("destoryPreUserMes");
        if (route.query.type) {
          router.push({
            name: "my",
            query: {
              pid: getLocalPid()
            }
          });
        } else {
          router.push({
            name: "my",
            query: {
              pid: getLocalPid()
            }
          });
        }
        return ElMessage.success("设置成功");
      }).catch(err => {
        return ElMessage.error(JSON.stringify(err));
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_3), _createTextVNode(" 设置阅读能力 ")]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(school, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          onClick: $event => getSchoolList(index),
          class: _normalizeClass(["item", {
            active: checked.value === item ? true : false
          }])
        }, [_createElementVNode("span", null, _toDisplayString(item), 1)], 10, _hoisted_7);
      }), 64))]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("select", {
        onChange: changeOption,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => user_grade_bak.value = $event)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPeriod.value, item => {
        return _openBlock(), _createElementBlock("option", {
          value: item.value,
          key: item.value
        }, _toDisplayString(item.name), 9, _hoisted_10);
      }), 128))], 544), [[_vModelSelect, user_grade_bak.value]]), _hoisted_11]), user_grade_bak.value === '' || user_grade_bak.value === init_user_grade_bak.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "font-bold text-center btn",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push('/my'))
      }, " 跳过 ")) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: "font-bold text-center btn",
        onClick: submit
      }, " 下一步 "))])])], 2);
    };
  }
};